import SetPassword from './set_password';

export default SetPassword;
